import React, { useState, useEffect } from "react";
import axios from "axios";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Download } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";

import "../assets/css/GroupLoanEmiDueReport.css";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import { toast } from "react-toastify";

const GroupLoanEmiDueReport = () => {
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.userProfile);

  /* ---------------- STATES ---------------- */
  const [centers, setCenters] = useState([]);
  const [groups, setGroups] = useState([]);
  const [selectedCenter, setSelectedCenter] = useState("");
  const [selectedGroup, setSelectedGroup] = useState("");
  const [dayFilter, setDayFilter] = useState("");

  const [emiData, setEmiData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [company,setCompany]=useState("");

  const ITEMS_PER_PAGE_OPTIONS = [10, 20, 50, 100,"All"];


  const companyName = company?.name || profile?.branchName || "Company";

  const selectedCenterName =
    centers.find((c) => c.id == selectedCenter)?.CenterName || "All";

  const selectedGroupName =
    groups.find((g) => g.id == selectedGroup)?.groupname || "All";

  const selectedFilterName = dayFilter || "All";



  /* ---------------- PROFILE ---------------- */
  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  /* ---------------- FETCH CENTERS ---------------- */
  useEffect(() => {
    if (!profile?.id) return;

    const fetchCenters = async () => {
      try {
        const res = await axios.get(
          `https://payyug.in/api/group/centre?LoanofficerId=${profile.id}`,
        );
        setCenters(res.data?.data || []);
      } catch (error) {
        console.error("Center fetch error:", error);
      }
    };

    fetchCenters();
  }, [profile?.id]);

  /* ---------------- FETCH GROUPS ---------------- */
  useEffect(() => {
    if (!selectedCenter) return;

    const fetchGroups = async () => {
      try {
        const res = await axios.get(
          `https://payyug.in/api/groupupdate/getall?LoanofficerId=${profile?.id}&CenterId=${selectedCenter}`,
        );
        setGroups(res.data?.data || []);
      } catch (error) {
        console.error("Group fetch error:", error);
      }
    };

    fetchGroups();
  }, [selectedCenter, profile?.id]);

  /* ---------------- FETCH EMI ---------------- */
  const fetchEmis = async (page = 1) => {
    if (!profile?.branchId) return;

    try {
      setLoading(true);

      const res = await axios.get(
        "https://payyug.in/api/group-loan/emi/list-filter",
        {
          params: {
            superAdminId: profile.superAdminId,
            // branchId: profile.branchId,
            centerId: selectedCenter || undefined,
            groupId: selectedGroup || undefined,
            page,
            filterType:dayFilter,
            limit: itemsPerPage==="All"?100000:itemsPerPage,
          },
        },
      );
      console.log("emi due", res.data);

      if (res.data?.success) {
        setEmiData(res.data.data || []);
        setCurrentPage(res.data.currentPage);
        setTotalPages(res.data.totalPages);
        setTotalRecords(res.data.totalRecords);
      }
    } catch (error) {
      console.error("EMI fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  /* 🔁 search / per-page / page change */
  useEffect(() => {
    if (!selectedCenter || !selectedGroup) return;
    fetchEmis(currentPage);
  }, [currentPage, itemsPerPage]);

  // const filteredData = emiData.filter((r) => {
  //   const text = `
  //   ${r.loanAccount?.loanAccountNumber}
  //   ${r.loanAccount?.memberName}
  //   ${r.loanAccount?.centerName}
  //   ${r.loanAccount?.groupName}
  // `.toLowerCase();

  //   if (!text.includes(searchQuery.toLowerCase())) return false;

  //   const dueDate = new Date(r.dueDate);
  //   const today = new Date();

  //   // remove time
  //   today.setHours(0, 0, 0, 0);
  //   dueDate.setHours(0, 0, 0, 0);

  //   if (dayFilter === "pending") {
  //     return !r.paidDate;
  //   }

  //   if (dayFilter === "today") {
  //     return !r.paidDate && dueDate.getTime() === today.getTime();
  //   }

  //   if (dayFilter === "upcoming") {
  //     return !r.paidDate && dueDate > today;
  //   }

  //   if (dayFilter === "overdue") {
  //     return !r.paidDate && dueDate < today;
  //   }

  //   return true;
  // });


    const filteredData = emiData.filter((r) => {
    const text = `
      ${r.loanAccount?.loanAccountNumber}
      ${r.loanAccount?.memberName}
      ${r.loanAccount?.centerName}
      ${r.loanAccount?.groupName}
    `.toLowerCase();

    return text.includes(searchQuery.toLowerCase());
  });
  /* ---------------- FILTER SUBMIT ---------------- */
  const handleFilter = () => {
    if (!selectedCenter || !selectedGroup) {
      toast.warn("Please select center and group");
      return;
    }

    setCurrentPage(1);
    fetchEmis(1);
  };

    useEffect(() => {
      const fetchCompany = async () => {
        try {
          const res = await fetch(
            `https://payyug.in/api/get-company?superAdminId=${profile?.superAdminId}`,
          );
          const data = await res.json();
          if (res.ok && data) {
            if (data.logo)
              data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
            setCompany(data);
          }
        } catch (err) {
          console.error("Failed to fetch company details", err);
        }
      };
  
      
      fetchCompany();
    }, [profile?.superAdminId]);

  /* ---------------- EXPORT ---------------- */
  // const exportCSV = () => {
  //   const csv = emiData
  //     .map((r) =>
  //       [
  //         r.loanAccount?.loanAccountNumber,
  //         r.loanAccount?.memberName,
  //         r.loanAccount?.groupName,
  //         r.emiAmount,
  //         r.dueDate,
  //       ].join(","),
  //     )
  //     .join("\n");

  //   saveAs(new Blob([csv]), "emi_due_report.csv");
  // };

  // const exportExcel = () => {
  //   const ws = XLSX.utils.json_to_sheet(emiData);
  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, "EMI Report");
  //   XLSX.writeFile(wb, "emi_due_report.xlsx");
  // };

  // const exportPDF = () => {
  //   const doc = new jsPDF("l", "pt", "a4");
  //   autoTable(doc, {
  //     head: [["Account No", "Member", "Group", "EMI", "Due Date", "Status"]],
  //     body: emiData.map((r) => {
  //       const status = r.paidDate
  //         ? "Paid"
  //         : new Date(r.dueDate) < new Date()
  //           ? "Overdue"
  //           : "Pending";

  //       return [
  //         r.loanAccount?.loanAccountNumber,
  //         r.loanAccount?.memberName,
  //         r.loanAccount?.groupName,
  //         r.emiAmount,
  //         new Date(r.dueDate).toLocaleDateString(),
  //         status,
  //       ];
  //     }),
  //   });
  //   doc.save("emi_due_report.pdf");
  // };

  const exportCSV = () => {
    const headerInfo = `
  Company: ${companyName}
  Address: ${company?.address}
  Email: ${company.email}
  Contact: ${company?.contact}
  Center: ${selectedCenterName}
  Group: ${selectedGroupName}
  Filter: ${selectedFilterName}

  `;

    const tableHeader =
      "Account No,Member,Group,EMI Amount,Due Date,Status\n";

    const tableData = emiData
      .map((r) => {
        const status = r.paidDate
          ? "Paid"
          : new Date(r.dueDate) < new Date()
          ? "Overdue"
          : "Pending";

        return [
          r.loanAccount?.loanAccountNumber,
          r.loanAccount?.memberName,
          r.loanAccount?.groupName,
          r.emiAmount,
          new Date(r.dueDate).toLocaleDateString("en-GB"),
          status,
        ].join(",");
      })
      .join("\n");

    const csvContent = headerInfo + tableHeader + tableData;

    saveAs(new Blob([csvContent]), "emi_due_report.csv");
  };


  const exportExcel = () => {
  const reportData = [
    ["Company", companyName],
    ["Address",company?.address],
    ["Contact",company?.contact],
    ["email",company?.email],
    ["Center", selectedCenterName],
    ["Group", selectedGroupName],
    ["Filter", selectedFilterName],
    [],
    ["Account No", "Member", "Group", "EMI", "Due Date", "Status"],
    ...emiData.map((r) => {
      const status = r.paidDate
        ? "Paid"
        : new Date(r.dueDate) < new Date()
        ? "Overdue"
        : "Pending";

      return [
        r.loanAccount?.loanAccountNumber,
        r.loanAccount?.memberName,
        r.loanAccount?.groupName,
        r.emiAmount,
        new Date(r.dueDate).toLocaleDateString("en-GB"),
        status,
      ];
    }),
  ];

  const ws = XLSX.utils.aoa_to_sheet(reportData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "EMI Report");
  XLSX.writeFile(wb, "emi_due_report.xlsx");
};


  const exportPDF = () => {
    const doc = new jsPDF("l", "pt", "a4");

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const todayDate = new Date().toLocaleDateString("en-GB");

    /* ================= HEADER ================= */

    // Blue Background Header
    doc.setFillColor(30, 144, 255);
    doc.rect(0, 0, pageWidth, 110, "F");

    // Company Name (Large)
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(18);
    doc.text(companyName?.toUpperCase() || "", 40, 35);

    // Company Details (Smaller Size)
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);

    doc.text(company?.address || "", 40, 55, { maxWidth: 500 });
    doc.text(`Email: ${company?.email || ""}`, 40, 70);
    doc.text(`Contact: ${company?.contact || ""}`, 40, 82);

    /* ================= REPORT TITLE ================= */

    doc.setTextColor(0, 0, 0);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("EMI DUE REPORT", 40, 135);

    /* ================= FILTER DETAILS ================= */

    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);

    doc.text(`Center : ${selectedCenterName}`, 40, 160);
    doc.text(`Group  : ${selectedGroupName}`, 40, 175);
    doc.text(`Filter : ${selectedFilterName}`, 40, 190);

    doc.text(`Generated On : ${todayDate}`, 350, 160);
    doc.text(`Total Records : ${emiData.length}`, 350, 175);

    /* ================= TABLE ================= */

    autoTable(doc, {
      startY: 210,
      head: [
        [
          "Account No",
          "Member",
          "Group",
          "Loan Amt",
          "EMI",
          "Due Date",
          "Status",
        ],
      ],
      body: emiData.map((r) => {
        const status = r.paidDate
          ? "Paid"
          : new Date(r.dueDate) < new Date()
          ? "Overdue"
          : "Pending";

        return [
          r.loanAccount?.loanAccountNumber,
          r.loanAccount?.memberName,
          r.loanAccount?.groupName,
          r.loanAccount?.loanAmount,
          r.emiAmount,
          new Date(r.dueDate).toLocaleDateString("en-GB"),
          status,
        ];
      }),
      styles: {
        fontSize: 9,
        cellPadding: 6,
        halign: "center",
        valign: "middle",
      },
      headStyles: {
        fillColor: [30, 144, 255],
        textColor: 255,
        fontStyle: "bold",
        halign: "center",
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245],
      },
      columnStyles: {
        6: { fontStyle: "bold" },
      },
    });

    /* ================= FOOTER ================= */

    doc.setFontSize(8);
    doc.setTextColor(120);
    doc.text(
      "This is a system generated report.",
      40,
      pageHeight - 20
    );

    doc.save("emi_due_report.pdf");
  };




  return (
    <div className="gledr-container">
      <h1 className="gledr-heading">
        <i className="bi bi-file-earmark-text"></i> EMI Due Report
      </h1>

      {/* FILTER */}
      <div className="gledr-filterBox">
        <div className="gledr-filter-title">Filter By</div>

        <div className="gledr-filter-wrapper">
          <div className="gledr-filter-item">
            <div className="gledr-filter">
              <label>Select Center</label>
              <select
                value={selectedCenter}
                onChange={(e) => setSelectedCenter(e.target.value)}
              >
                <option value="">Select Center</option>
                {centers.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.CenterName}
                  </option>
                ))}
              </select>
            </div>

            <div className="gledr-filter">
              <label>Select Group</label>
              <select
                value={selectedGroup}
                onChange={(e) => setSelectedGroup(e.target.value)}
              >
                <option value="">Select Group</option>
                {groups.map((g) => (
                  <option key={g.id} value={g.id}>
                    {g.groupname}, {g.groupcode}
                  </option>
                ))}
              </select>
            </div>

            <div className="gledr-filter">
              <label>Select Filter</label>
              <select
                value={dayFilter}
                onChange={(e) => setDayFilter(e.target.value)}
              >
                <option value="">All</option>
                <option value="today">Today</option>
                <option value="tomorrow">Tomorrow</option>
                <option value="pending">Pending</option>
                <option value="overdue">Overdue</option>
              </select>
            </div>
          </div>

          <div className="gledr-filter-submit-btn">
            <button className="submit-btn" onClick={handleFilter}>
              submit
            </button>
          </div>
        </div>
      </div>

      {/* EXPORT */}
      {filteredData.length > 0 && (
        <div className="gledr-pdf-download-btns">
          <button onClick={exportCSV}>
            <Download size={15} /> CSV
          </button>
          <button onClick={exportExcel}>
            <Download size={15} /> Excel
          </button>
          <button onClick={exportPDF}>
            <Download size={15} /> PDF
          </button>
        </div>
      )}

      {/* 🔍 SEARCH + PER PAGE */}
      <div className="gledr-report-filter">
        <input
          placeholder="Search..."
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value);
            setCurrentPage(1);
          }}
        />

        <div className="gledr-report-filter-inputs">
          <label>Show </label>
          <select
            value={itemsPerPage}
            onChange={(e) => {
              const value=e.target.value;
              setItemsPerPage(value==="All"?"All": Number(value));
              setCurrentPage(1);
            }}
          >
            {ITEMS_PER_PAGE_OPTIONS.map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
          <span> entries</span>
        </div>
      </div>

      {/* TABLE */}
      <div className="gledr-report-table-container">
        <table className="gledr-report-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Loan Account No</th>
              <th>Loan Amount</th>
              <th>Member</th>
              {/* <th>Centre</th> */}
              <th>Group</th>
              <th>EMI Amount</th>
              <th>Due Date</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="9" align="center">
                  Loading...
                </td>
              </tr>
            ) : filteredData.length ? (
              filteredData.map((r, i) => {

                return (
                  <tr key={r.id}>
                    <td>{itemsPerPage==="All"?i+1:(currentPage - 1) * itemsPerPage + i + 1}</td>
                    <td>{r.loanAccount?.loanAccountNumber}</td>
                    <td>{r.loanAccount?.loanAmount}</td>
                    <td>{r.loanAccount?.memberName}</td>
                    {/* <td>{r.loanAccount?.centerName}</td> */}
                    <td>{r.loanAccount?.groupName}</td>
                    <td>₹{r.emiAmount}</td>
                    <td>{new Date(r.dueDate).toLocaleDateString("en-GB")}</td>
                    <td
                      className={
                        r.status.toLowerCase() === "paid"
                          ? "status-paid"
                          : r.status.toLowerCase() === "pending"
                            ? "status-pending"
                            : "status-overdue"
                      }
                      style={{textTransform:"capitalize"}}
                    >
                      { r.status.toLowerCase()}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="8" align="center">
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* PAGINATION */}
      {/* <div className="gledr-pagination">
        <button
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((p) => p - 1)}
        >
          ⬅ Prev
        </button>
        <span>
          Page {currentPage} of {totalPages}
        </span>
        <button
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage((p) => p + 1)}
        >
          Next ➡
        </button>
      </div> */}
      {itemsPerPage!=="All" && (
      <div className="gledr-pagination">
        <button
          disabled={currentPage === 1 || filteredData.length === 0}
          onClick={() => setCurrentPage((p) => p - 1)}
        >
          ⬅ Prev
        </button>

        <span>
          {filteredData.length === 0
            ? "No data"
            : `Page ${currentPage} of ${totalPages}`}
        </span>

        <button
          disabled={currentPage === totalPages || filteredData.length === 0}
          onClick={() => setCurrentPage((p) => p + 1)}
        >
          Next ➡
        </button>
      </div>
      )}
    </div>
  );
};

export default GroupLoanEmiDueReport;
